export default "__VITE_ASSET__DGDhlwco__"